import { useFeatureEnabled } from './useFeatureEnabled';

export function useFeatureMemberPreferences(): boolean {
  return useFeatureEnabled('MEMBER_PREFERENCES');
}

export function useFeatureMemberPortalMemberPreferences(): boolean {
  return useFeatureEnabled('PORTAL_MEMBER_PREFERENCES');
}
